module.exports = __webpack_public_path__ + "static/media/trollaa-jaipur.e73ddfea.png";